// extracted by mini-css-extract-plugin
export default {"container":"Origin_container__hN3en","video":"Origin_video__PXqJG"};